// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "sparkle-div {\n  display: block;\n  overflow: hidden;\n}\nsparkle-div.cover {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\nsparkle-div sparkle-star-div {\n  display: block;\n  position: absolute;\n  animation-name: sparkle;\n  animation-duration: 4s;\n  animation-timing-function: linear;\n  object-fit: contain;\n}\nsparkle-div sparkle-star-div * {\n  object-fit: contain;\n}\n@keyframes sparkle {\n  0% {\n    transform: scale(0) rotate(0deg);\n    opacity: 0;\n  }\n  67% {\n    transform: scale(3) rotate(360deg);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(0) rotate(540deg);\n    opacity: 0;\n  }\n}\n", ""]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/less-loader/dist/cjs.js!./src/main.less
// module id = 3
// module chunks = 0